// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__LK-Xi","buttons":"PendingPaymentAlert_buttons__1WAQo"};